import React from 'react';

const FindYourFitChart = ({ chart }) => {
  return (
    <table className='find-your-fit__chart'>
      <thead>
        <tr>
          <th>{chart.title}</th>
        </tr>
      </thead>
      <tbody>
        {chart.values.map((val) => (
          <tr key={`${chart.title}-${val}`}>
            <td>{val}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const FindYourFit = ({ charts, note }) => {
  return (
    <div id='FindYourFit' className='find-your-fit'>
      <h2 className='find-your-fit__title'>Find Your Fit</h2>

      <div className='find-your-fit__charts'>
        {charts.map((chart, idx) => (
          <FindYourFitChart key={chart + idx} chart={chart} />
        ))}
      </div>

      {note && <p className='find-your-fit__note' dangerouslySetInnerHTML={{ __html: note }}></p>}
    </div>
  );
};

export default FindYourFit;
